export default __webpack_public_path__ + "static/media/Prakash.e5dc7128.jpeg";